import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, NavLink } from 'react-router-dom';
import ContactWidget from './components/ContactWidget';
import './App.css';

import Home from './pages/Home';
import Download from './pages/Download';
import Clubs from './pages/Clubs';
import Guide from './pages/Guide';
import InstallGuide from './pages/InstallGuide';
import KeywordOfficial from './pages/KeywordOfficial';
import KeywordDownload from './pages/KeywordDownload';
import KeywordLatestDownload from './pages/KeywordLatestDownload';
import KeywordClubId from './pages/KeywordClubId';
import KeywordInstallGuide from './pages/KeywordInstallGuide';
import KeywordContactService from './pages/KeywordContactService';
import Contact from './pages/Contact';
import GuideDetail from './pages/GuideDetail';
import NotFound from './pages/NotFound';

// 加载中的占位组件
const LoadingFallback = () => (
  <div style={{
    height: '100vh', 
    width: '100%', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    background: '#1a1c29',
    color: '#efa765'
  }}>
    加载中...
  </div>
);

function App() {
  const [mobileOpen, setMobileOpen] = useState(false);
  
  // 检测是否为移动端，用于控制底部栏显示
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // prevent background scroll when mobile menu open
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <Router>
      <header className="site-header" style={{background:'#1a1c29', height: '60px', padding:'0', boxShadow:'0 2px 8px rgba(0,0,0,0.2)', position: 'sticky', top: 0, zIndex: 1000}}>
        <div className="header-container" style={{maxWidth:'100%', height: '100%', margin:'0 auto', padding:'0 16px', display:'flex', alignItems:'center', justifyContent: 'space-between', position:'relative'}}>
          
          {/* Logo 区 */}
          <Link to="/" style={{display:'flex', alignItems:'center', textDecoration: 'none'}}>
            {/* 建议更换为更简洁的 Logo 图标 */}
            <img src="/images/logo.png" alt="HH" style={{height:'32px', marginRight:'8px', verticalAlign:'middle'}} />
            {/* <span style={{fontFamily:'Yeseva One, serif', fontWeight:700, fontSize:'1.2rem', color:'#fff', letterSpacing:'1px'}}>HHPOKER</span> */}
          </Link>

          {/* PC 端导航 */}
          <nav className={`main-nav ${mobileOpen ? 'mobile-open' : ''}`} style={{flex:1, display: isMobile ? 'none' : 'block'}}>
             <ul style={{display:'flex', justifyContent: 'flex-end', alignItems:'center', margin:0, padding:0, listStyle:'none'}}>
              <li style={{margin:'0 20px'}}>
                <NavLink to="/" className={({isActive}) => isActive ? 'nav-active' : ''} style={{color:'#fff', fontWeight:600}}>首页</NavLink>
              </li>
              <li style={{margin:'0 20px'}}>
                <NavLink to="/download/" className={({isActive}) => isActive ? 'nav-active' : ''} style={{color:'#fff', fontWeight:600}}>客户端下载</NavLink>
              </li>
              <li style={{margin:'0 20px'}}>
                <NavLink to="/clubs/" className={({isActive}) => isActive ? 'nav-active' : ''} style={{color:'#fff', fontWeight:600}}>战队列表</NavLink>
              </li>
              <li style={{margin:'0 20px'}}>
                <NavLink to="/guide/" className={({isActive}) => isActive ? 'nav-active' : ''} style={{color:'#fff', fontWeight:600}}>进阶攻略</NavLink>
              </li>
              <li style={{margin:'0 20px'}}>
                <NavLink to="/contact/" className={({isActive}) => isActive ? 'nav-active' : ''} style={{color:'#fff', fontWeight:600}}>联系客服</NavLink>
              </li>
            </ul>
          </nav>

          {/* 移动端菜单按钮 */}
          <button className="mobile-menu-button" aria-label="菜单" onClick={() => setMobileOpen(o => !o)} style={{padding: '8px', background: 'transparent', border: 'none'}}>
            {!mobileOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#efa765" strokeWidth="2" strokeLinecap="round" strokeJoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#efa765" strokeWidth="2" strokeLinecap="round" strokeJoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
            )}
          </button>

          {/* 移动端全屏菜单 */}
          <div className={`mobile-nav-menu ${mobileOpen ? 'active' : ''}`}>
             <NavLink to="/" onClick={() => setMobileOpen(false)}>首页</NavLink>
             <NavLink to="/download/" onClick={() => setMobileOpen(false)}>客户端下载</NavLink>
             <NavLink to="/clubs/" onClick={() => setMobileOpen(false)}>精选战队</NavLink>
             <NavLink to="/guide/" onClick={() => setMobileOpen(false)}>游戏攻略</NavLink>
             <NavLink to="/contact/" onClick={() => setMobileOpen(false)}>联系客服</NavLink>
          </div>

          {isMobile && mobileOpen && <div className="mobile-nav-overlay" onClick={() => setMobileOpen(false)} />}
        </div>
      </header>

      <main style={{paddingBottom: isMobile ? '70px' : '0'}}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/download" element={<Download />} />
          <Route path="/clubs" element={<Clubs />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/install-guide" element={<InstallGuide />} />
          <Route path="/hhpoker-official" element={<KeywordOfficial />} />
          <Route path="/hhpoker-download" element={<KeywordDownload />} />
          <Route path="/hhpoker-latest-download" element={<KeywordLatestDownload />} />
          <Route path="/hhpoker-club-id" element={<KeywordClubId />} />
          <Route path="/hhpoker-install-guide" element={<KeywordInstallGuide />} />
          <Route path="/hhpoker-contact-service" element={<KeywordContactService />} />
          <Route path="/guide/detail" element={<GuideDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      {/* 底部悬浮栏 (仅移动端) */}
      {isMobile && (
        <div style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '60px',
          background: 'rgba(26, 28, 41, 0.98)',
          borderTop: '1px solid #333',
          display: 'flex',
          zIndex: 999,
          boxShadow: '0 -2px 10px rgba(0,0,0,0.3)',
          backdropFilter: 'blur(10px)'
        }}>
          <Link to="/contact/" style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#aaa',
            textDecoration: 'none',
            fontSize: '12px'
          }}>
            <span style={{fontSize: '20px'}}>💬</span>
            <span>客服</span>
          </Link>
          <Link to="/download/" style={{
            flex: 2,
            background: 'linear-gradient(90deg, #efa765, #f5b97f)',
            color: '#1a1c29',
            textDecoration: 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '16px',
            margin: '8px',
            borderRadius: '30px'
          }}>
            立即下载 APP
          </Link>
        </div>
      )}

      <ContactWidget hideSidebar={isMobile} />
    </Router>
  );
}

export default App;
